import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../../components/apiconfig/api-config';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const validateForm = (values) => {
  const errors = {};
  if (!values.name || values.name.trim() === "") {
    errors.name = "Name is required";
  } else if (values.name.length > 100) {
    errors.name = "Name cannot exceed 100 characters";
  }
  if (!values.license_no || values.license_no.trim() === "") {
    errors.license_no = "License No is required";
  } else if (values.license_no.length > 50) {
    errors.license_no = "License No cannot exceed 50 characters";
  }
  if (!values.contact_phone || values.contact_phone.trim() === "") {
    errors.contact_phone = "Contact phone is required";
  } else if (!/^\d{10}$/.test(values.contact_phone)) {
    errors.contact_phone = "Enter a valid phone number (10digits)";
  }
  if (values.default_port && values.default_port.length > 100) {
    errors.default_port = "Default Port cannot exceed 100 characters";
  }
  if (values.email_id && values.email_id.length > 100) {
    errors.email_id = "Email cannot exceed 100 characters";
  }
  if (!values.email_id || values.email_id.trim() === "") {
    errors.email_id = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email_id)) {
    errors.email_id = "Enter a valid email address";
  }
  if (values.fax_no && values.fax_no.length > 30) {
    errors.fax_no = "Fax No cannot exceed 30 characters";
  }
  if (values.website && values.website.length > 100) {
    errors.website = "Website cannot exceed 100 characters";
  } else if (
    values.website &&
    !/^((https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?)$/.test(values.website)
  ) {
    errors.website = "Enter a valid website (e.g. www.example.com)";
  }
  if (values.currency && values.currency.length > 10) {
    errors.currency = "Currency cannot exceed 10 characters";
  }
  if (values.bank_name && values.bank_name.length > 100) {
    errors.bank_name = "Bank Name cannot exceed 100 characters";
  }
  if (values.account_no && values.account_no.length > 50) {
    errors.account_no = "Account No cannot exceed 50 characters";
  }
  if (values.swift_code && values.swift_code.length > 50) {
    errors.swift_code = "SWIFT Code cannot exceed 50 characters";
  }
  if (values.ad_code && values.ad_code.length > 50) {
    errors.ad_code = "AD Code cannot exceed 50 characters";
  }
  if (values.vat_gst_no && values.vat_gst_no.length > 50) {
    errors.vat_gst_no = "VAT/GST No cannot exceed 50 characters";
  }
  if (values.aadhar_no && values.aadhar_no.length > 50) {
    errors.aadhar_no = "Aadhar No cannot exceed 50 characters";
  }
  return errors;
};

const validateField = (name, value) => {
  let error = "";
  if (name === "name") {
    if (!value.trim()) error = "Name is required";
    else if (value.length > 100) error = "Name cannot exceed 100 characters";
  }
  if (name === "license_no") {
    if (!value.trim()) error = "License No is required";
    else if (value.length > 50) error = "License No cannot exceed 50 characters";
  }
  if (name === "contact_phone") {
    if (!value.trim()) error = "Contact phone is required";
    else if (!/^\d{10}$/.test(value)) error = "Contact phone must be exactly 10 digits";
  }
  if (name === "default_port") {
    if (value && value.length > 100) error = "Default Port cannot exceed 100 characters";
  }
  if (name === "email_id") {
    if (!value.trim()) error = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = "Enter a valid email address";
    else if (value.length > 100) error = "Email cannot exceed 100 characters";
  }
  if (name === "fax_no") {
    if (value && value.length > 30) error = "Fax No cannot exceed 30 characters";
  }
  if (name === "website") {
    if (value && value.length > 100) error = "Website cannot exceed 100 characters";
    else if (
      value &&
      !/^((https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?)$/.test(value)
    ) error = "Enter a valid website (e.g. www.example.com)";
  }
  if (name === "currency") {
    if (value && value.length > 10) error = "Currency cannot exceed 10 characters";
  }
  if (name === "bank_name") {
    if (value && value.length > 100) error = "Bank Name cannot exceed 100 characters";
  }
  if (name === "account_no") {
    if (value && value.length > 50) error = "Account No cannot exceed 50 characters";
  }
  if (name === "swift_code") {
    if (value && value.length > 50) error = "SWIFT Code cannot exceed 50 characters";
  }
  if (name === "ad_code") {
    if (value && value.length > 50) error = "AD Code cannot exceed 50 characters";
  }
  if (name === "vat_gst_no") {
    if (value && value.length > 50) error = "VAT/GST No cannot exceed 50 characters";
  }
  if (name === "aadhar_no") {
    if (value && value.length > 50) error = "Aadhar No cannot exceed 50 characters";
  }
  return error;
};

const ChaForm = () => {
  const { id } = useParams();
  const isEditMode = !!id;
  const [formData, setFormData] = useState({
    name: '',
    license_no: '',
    contact_phone: '',
    default_port: '',
    address: '',
    email_id: '',
    fax_no: '',
    website: '',
    currency: '',
    bank_name: '',
    account_no: '',
    swift_code: '',
    ad_code: '',
    vat_gst_no: '',
    aadhar_no: ''
  });
  const [originalFormData, setOriginalFormData] = useState({
    name: '',
    license_no: '',
    contact_phone: '',
    default_port: '',
    address: '',
    email_id: '',
    fax_no: '',
    website: '',
    currency: '',
    bank_name: '',
    account_no: '',
    swift_code: '',
    ad_code: '',
    vat_gst_no: '',
    aadhar_no: ''
  });
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch CHA data for editing
  useEffect(() => {
    if (isEditMode && id) {
      setInitialLoading(true);
      console.log('Fetching CHA with ID:', id);
      const fetchCHA = async () => {
        try {
          const url = `${API_BASE_URL}/api/masters/cha-get/${id}`;
          console.log('Fetching from URL:', url);
          const res = await fetch(url, {
            credentials: 'include',
          });
          console.log('Response status:', res.status);
          if (!res.ok) {
            console.error('Response not ok:', res.status, res.statusText);
            throw new Error('Failed to fetch CHA');
          }
          const result = await res.json();
          console.log('Fetched CHA data:', result);
          if (result.data) {
            console.log('Setting form data:', result.data);
            const newFormData = {
              name: result.data.name ?? '',
              license_no: result.data.license_no ?? '',
              contact_phone: result.data.contact_phone ?? '',
              default_port: result.data.default_port ?? '',
              address: result.data.address ?? '',
              email_id: result.data.email_id ?? '',
              fax_no: result.data.fax_no ?? '',
              website: result.data.website ?? '',
              currency: result.data.currency ?? '',
              bank_name: result.data.bank_name ?? '',
              account_no: result.data.account_no ?? '',
              swift_code: result.data.swift_code ?? '',
              ad_code: result.data.ad_code ?? '',
              vat_gst_no: result.data.vat_gst_no ?? '',
              aadhar_no: result.data.aadhar_no ?? ''
            };
            console.log('Setting new form data:', newFormData);
            setFormData(newFormData);
            setOriginalFormData(newFormData); // Store original values for read-only check
          } else {
            toast.error('CHA not found');
            navigate('/cha');
          }
        } catch (error) {
          console.error('Error fetching CHA:', error);
          toast.error('Failed to load CHA data');
          navigate('/cha');
        } finally {
          setInitialLoading(false);
        }
      };
      fetchCHA();
    }
  }, [id, isEditMode, navigate]);

  // Debug: Monitor formData changes
  useEffect(() => {
    console.log('FormData changed:', formData);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Check if field is read-only (has existing value from database)
    const isReadOnly = (fieldName) => {
      // Only check if this is edit mode and the field had an original value
      if (!isEditMode) return false;
      
      // Get the original value from the database (stored separately)
      const originalValue = originalFormData[fieldName];
      return originalValue && originalValue.toString().trim() !== '';
    };
    
    // Don't allow changes to read-only fields
    if (isReadOnly(name)) {
      return;
    }
    
    setFormData(prev => ({ ...prev, [name]: value }));
    // Validate this field
    const error = validateField(name, value);
    if (error) {
      // Don't set formErrors since we're not using it
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    if (error) {
      toast.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const errors = validateForm(formData);
    if (Object.keys(errors).length > 0) {
      // Show all errors as toasts
      Object.values(errors).forEach((msg) => {
        if (msg) toast.error(msg);
      });
      setLoading(false);
      return;
    }
    // Prepend https:// to website if not present
    let submitData = { ...formData };
    if (
      submitData.website &&
      !/^https?:\/\//.test(submitData.website)
    ) {
      submitData.website = "https://" + submitData.website;
    }
    try {
      const url = isEditMode 
        ? `${API_BASE_URL}/api/masters/cha-put/${id}`
        : `${API_BASE_URL}/api/masters/cha-post`;
      
      console.log('=== SUBMITTING CHA DATA ===');
      console.log('URL:', url);
      console.log('Method:', isEditMode ? 'PUT' : 'POST');
      console.log('Form data being sent:', submitData);
      
      const res = await fetch(url, {
        method: isEditMode ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(submitData),
        credentials: 'include',
      });
      const data = await res.json();
      if (res.ok) {
        toast.success(isEditMode ? 'CHA Updated Successfully!' : 'CHA Registered Successfully!');
        if (!isEditMode) {
          setFormData({ name: '', license_no: '', contact_phone: '', default_port: '', address: '', email_id: '', fax_no: '', website: '', currency: '', bank_name: '', account_no: '', swift_code: '', ad_code: '', vat_gst_no: '', aadhar_no: '' });
        } else {
          navigate('/cha');
        }
      } else {
        toast.error(data.error || 'Something went wrong');
      }
    } catch (err) {
      toast.error('Server Error');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-8xl mx-auto p-4 bg-white">
      <ToastContainer />
      {initialLoading ? (
        <div className="text-center py-8 text-blue-600">Loading...</div>
      ) : (
        <>
          <div className="flex justify-between items-center border-b pb-3 mb-5">
            <h2 className="text-lg font-medium text-gray-800">{isEditMode ? 'Edit CHA' : 'CHA Registration'}</h2>
            <div className="flex items-center gap-4">
              {isEditMode && (
                <div className="text-xs text-gray-600">
                  <span className="inline-block w-3 h-3 bg-gray-100 border border-gray-300 mr-1"></span>
                  Read-only fields
                </div>
              )}
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="flex items-center gap-1 text-[#10a5e9] border border-[#10a5e9] px-3 py-1 text-xs rounded  font-normal hover:bg-[#10a5e9] hover:text-white hover:border-[#10a5e9] transition"
              >
                <FaArrowLeft />
                Back
              </button>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1">Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" required autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">License No</label>
            <input type="text" name="license_no" value={formData.license_no} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" required autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Contact Phone</label>
            <input type="text" name="contact_phone" value={formData.contact_phone} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" required autoComplete="off" maxLength={10} />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Default Port</label>
            <input type="text" name="default_port" value={formData.default_port} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" required autoComplete="off" />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm text-gray-700 mb-1">Address</label>
            <textarea name="address" value={formData.address} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none resize-none" rows={2} autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Email ID</label>
            <input type="email" name="email_id" value={formData.email_id} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Fax No</label>
            <input type="text" name="fax_no" value={formData.fax_no} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Website</label>
            <input type="text" name="website" value={formData.website} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Currency</label>
            <input type="text" name="currency" value={formData.currency} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Bank Name</label>
            <input type="text" name="bank_name" value={formData.bank_name} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Account No</label>
            <input type="text" name="account_no" value={formData.account_no} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">SWIFT Code</label>
            <input type="text" name="swift_code" value={formData.swift_code} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">AD Code</label>
            <input type="text" name="ad_code" value={formData.ad_code} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">VAT/GST No</label>
            <input type="text" name="vat_gst_no" value={formData.vat_gst_no} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Aadhar No</label>
            <input type="text" name="aadhar_no" value={formData.aadhar_no} onChange={handleChange} onBlur={handleBlur} className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none" autoComplete="off" />
          </div>
        </div>
        <div className="pt-2 flex items-center gap-3">
          <button type="submit" className="px-4 py-2 text-xs  bg-[#10a5e9] text-white font-normal rounded border border-[#10a5e9] hover:bg-[#0e8ac2] transition disabled:opacity-60" style={{ minWidth: '110px' }} disabled={loading}>
            {loading ? 'Saving...' : (isEditMode ? 'Update CHA' : 'Save CHA')}
          </button>
        </div>
      </form>
        </>
      )}
    </div>
  );
};

export default ChaForm;